<p class="title">
    <img src="assets/images/edit.svg" alt="Image" class="icon-title" />
    {{ texts.titulo }}
  </p>

  <div class="container">
    <div id="mainDiv" class="form-container">

      <!-- Primeira Linha -->
      <div class="row">
        <div class="form-group">
          <label>{{ texts.tipo_pessoa }}</label>
          <p-dropdown id="tipoPessoa" [options]="tipoPessoa" [(ngModel)]="form.tipoPessoa" optionLabel="label"
            [placeholder]="placeholders.selecione_tipo_pessoa"
            (onChange)="onTipoPessoaChange()"></p-dropdown>
        </div>
        <div class="form-group" *ngIf="form.tipoPessoa?.value === 'FISICA'">
          <label>{{ texts.ci }}</label>
          <input type="text" pInputText [(ngModel)]="form.ci" [placeholder]="placeholders.ci" class="input-field" />
        </div>
        <div class="form-group" *ngIf="form.tipoPessoa?.value === 'JURIDICA'">
          <label>{{ texts.ruc }}</label>
          <input type="text" pInputText [(ngModel)]="form.ruc" [placeholder]="placeholders.ruc" class="input-field" />
        </div>
        <div class="form-group">
          <label>{{ texts.nome }}</label>
          <input type="text" pInputText [(ngModel)]="form.nome" [placeholder]="placeholders.nome" class="input-field" />
        </div>
      </div>

      <!-- Segunda Linha -->
      <div class="row">
        <div class="form-group">
          <label>{{ texts.nome_fantasia }}</label>
          <input type="text" pInputText [(ngModel)]="form.fantasia" [placeholder]="placeholders.nome_fantasia" class="input-field" />
        </div>
        <div class="form-group">
          <label>{{ texts.email }}</label>
          <input type="email" pInputText [(ngModel)]="form.email" [placeholder]="placeholders.email" class="input-field" />
        </div>
        <div class="form-group">
          <app-phone-input
            [(telefone)]="form.telefone"
            [(ddi)]="paisSelecionado"
            [label]="texts.telefone"
            [placeholder]="placeholders.telefone">
          </app-phone-input>
        </div>
      </div>

      <!-- Terceira Linha -->
      <div class="row">
        <div class="form-group">
          <label>{{ texts.endereco }}</label>
          <input type="text" pInputText [(ngModel)]="form.endereco" [placeholder]="placeholders.endereco"
            class="input-field" />
        </div>
        <div class="form-group">
          <label>{{ texts.numero }}</label>
          <input type="text" pInputText [(ngModel)]="form.numero" [placeholder]="placeholders.numero" class="input-field" />
        </div>
        <div class="form-group">
          <label>{{ texts.cidade }}</label>
          <p-dropdown id="selecionarCidade" [options]="cidadeList" [(ngModel)]="form.cidade"
            optionLabel="label" [placeholder]="placeholders.selecione_cidade" [filter]="true" filterBy="label"
            [showClear]="true" appendTo="body" panelStyleClass="ddi-dropdown-panel-erp"
            scrollHeight="340px"></p-dropdown>
        </div>
      </div>

      <!-- Quarta Linha -->
      <div class="row">
        <div class="form-group">
          <label>{{ texts.tipo_natureza_fiscal }}</label>
          <p-dropdown id="tipoNaturezaFiscal" [options]="tipoNaturezaFiscal" [(ngModel)]="form.tipoNaturezaFiscal"
            optionLabel="label" [placeholder]="placeholders.selecione_natureza_fiscal"></p-dropdown>
        </div>
        <div class="form-group">
            <label>{{ texts.data_nascimento }}</label>
            <p-calendar [(ngModel)]="form.dataNascimento" dateFormat="dd/mm/yy" [placeholder]="placeholders.data_nascimento"
              class=""></p-calendar>
          </div>
        <div class="form-group">
          <label>{{ texts.sexo }}</label>
          <p-dropdown id="sexo" [options]="sexo" [(ngModel)]="form.sexo" optionLabel="label"
            [placeholder]="placeholders.selecione_sexo"></p-dropdown>
        </div>
      </div>

      <div class="actions-container">
        <button pButton [label]="botoes.enviar" icon="pi pi-check" (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary"></button>
      </div>
    </div>
  </div>
